import { Header } from "@/components/SiteUI";
import { TestList } from "@/components/test/TestList";
import SEO from "@/components/SEO/SEO";
import ShareButtons from "@/components/ui/share-buttons";

export const TestsPage = () => {
  return (
    <>
      <SEO 
        title="Психологические тесты"
        description="Бесплатные психологические тесты для самоанализа: тест Бека, СМИ, тест молодости. Узнайте больше о своем психологическом состоянии."
        keywords="психологические тесты, тест бека, тест СМИ, тест молодости, бесплатный тест психолог, онлайн тест психология"
        url="/tests"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Психологические тесты",
          "description": "Бесплатные психологические тесты для самоанализа: тест Бека, СМИ, тест молодости. Узнайте больше о своем психологическом состоянии.",
          "url": "https://cope.by/tests",
          "mainEntity": {
            "@type": "SoftwareApplication",
            "name": "Психологические тесты",
            "applicationCategory": "HealthApplication",
            "operatingSystem": "Web Browser"
          }
        }}
      />
      <div className="min-h-screen px-4 sm:px-8 py-8 max-w-6xl mx-auto">
      <Header />
      <div className="bg-card rounded-lg border p-6 mt-16">
        <div className="flex items-center justify-between mb-4">
          <h2 className="mt-2 text-center text-2xl font-serif text-olive-950">Психологические тесты</h2>
          <ShareButtons 
            title="Бесплатные психологические тесты"
            description="Пройдите бесплатные психологические тесты: тест Бека, СМИ, тест молодости. Узнайте больше о своем психологическом состоянии."
            url="/tests"
            showText={false}
          />
        </div>

        <div className="flex flex-col gap-4 w-full items-center">
          <TestList className="max-w-3xl" />
        </div>
      </div>
      </div>
    </>
  );
};
